import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useUserContext } from "@/context/UserContext";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

type DecodedToken = {
  id: string;
  email: string;
  role: "ADMIN" | "CLIENT";
  exp: number;
  iat: number;
};

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const { userDetails } = useUserContext();
  const location = useLocation();

  // Check if the token belongs to an admin — redirect to admin dashboard
  const token = Cookies.get("token");
  if (token) {
    try {
      const decoded = jwtDecode<DecodedToken>(token);
      if (decoded.role === "ADMIN") {
        return <Navigate to="/admin/companies" replace />;
      }
    } catch {
      // Invalid token, continue with normal flow
    }
  }

  if (!isAuthenticated && !isLoading) {
    return <Navigate to="/login" replace />;
  }

  if (isLoading || userDetails === undefined) {
    return <div>Loading...</div>;
  }

  if (userDetails === null) {
    return <Navigate to="/login" replace />;
  }

  const isProfileIncomplete = !userDetails?.company?.website;
  const isOnCreateProfilePage = location.pathname === "/create-profile";

  if (isProfileIncomplete && !isOnCreateProfilePage) {
    return <Navigate to="/create-profile" replace />;
  }

  return <>{children}</>;
}
